
export class CommonModel {

    createdUserId: string;
    createdUserUsername: string;
    createdUserFullname: string;
    createdDate: string;
    updatedUserId: string;
    updatedUserUsername: string;
    updatedUserFullname: string;
    updatedDate: string;
    version: number;
}

export class CommonResponse {
    content:{
        status: string;
        errorCode: string;
        message: string;
    }
}
